import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import 'bootstrap/dist/css/bootstrap.min.css';
import * as serviceWorker from "./serviceWorker";
import { AuthProvider } from "./store/auth";

ReactDOM.render(
    <AuthProvider>
      <App />
    </AuthProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
